import {Controller} from "stimulus"
import StimulusReflex from 'stimulus_reflex'

const CONFIRM_PLAY_CLASS = 'show';

export default class extends Controller {
    static targets = ["video", "confirmPlay"];

    isPlaying = false;
    timerInterval = null;
    clearTimerInterval = () => {
        clearInterval(this.timerInterval);
    };

    connect() {
        StimulusReflex.register(this);
        this.timerInterval = setInterval(() => {
            this.play();
            if (this.isPlaying) {
                this.clearTimerInterval();
            }
        }, 500)
    }

    disconnect() {
        this.clearTimerInterval();
    }

    play() {
        if (this.hasVideoTarget) {
            this.videoTarget.muted = false;
            this.videoTarget.play()
                .then(() => {
                    this.confirmPlayTarget.classList.remove(CONFIRM_PLAY_CLASS);
                    this.isPlaying = true;
                })
                .catch((err) => {
                    this.confirm_play();
                    console.log('err', err)
                });
        }
    }

    confirm_play() {
        this.confirmPlayTarget.classList.add(CONFIRM_PLAY_CLASS);
        this.isPlaying = false
    }

    pause() {
        const video = this.videoTarget;
        if (video.currentTime !== video.duration) {
            this.confirm_play();
        } else {
            this.stimulate('game#finished_video');
        }
    }
}
